import { isBrowser } from '../utils/is-browser.mjs';

// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function supportsPointerEvents() {
  return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function supportsTouchEvents() {
  return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function supportsMouseEvents() {
  return isBrowser && window.onmousedown === null;
};
export { supportsMouseEvents, supportsPointerEvents, supportsTouchEvents };